/**
 * Safely stringifies a JSON-LD schema for use in HTML script tags.
 *
 * Accepts both string and object inputs. If a string is provided, it will be
 * parsed first. The resulting JSON string has `<` characters escaped as `\u003c`
 * to prevent XSS attacks when used with dangerouslySetInnerHTML.
 *
 * Based on Next.js recommendation: https://nextjs.org/docs/app/guides/json-ld
 *
 * @param jsonLd - The JSON-LD schema object or string to safely stringify
 * @returns A sanitized JSON string safe for use in dangerouslySetInnerHTML
 */

export const safeJsonLd = (jsonLd: unknown): string => {
  const obj = typeof jsonLd === 'string' ? JSON.parse(jsonLd) : jsonLd;

  return JSON.stringify(obj).replace(/</g, '\\u003c');
};
